
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/product/[...params]",
      function () {
        return require("private-next-pages/stores/product/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/product/[...params]"])
      });
    }
  